import { JSX } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export default function MDIcon(props: SvgIconProps): JSX.Element {
  return (
    <SvgIcon
      width="12"
      height="13"
      viewBox="0 0 12 13"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.6667 0.5H1.33333C0.6 0.5 0 1.1 0 1.83333V11.1667C0 11.9 0.6 12.5 1.33333 12.5H10.6667C11.4 12.5 12 11.9 12 11.1667V1.83333C12 1.1 11.4 0.5 10.6667 0.5ZM2 8.5V4.5H3.2L4 6.1L4.8 4.5H6V8.5H5V6.2L4 7.8L3 6.2V8.5H2ZM7 4.5H8.2C9.3 4.5 10 5.2 10 6.5C10 7.8 9.3 8.5 8.2 8.5H7V4.5ZM8 5.5V7.5H8.2C8.8 7.5 9 7.1 9 6.5C9 5.9 8.8 5.5 8.2 5.5H8Z"
        fill={props.fill}
      />
    </SvgIcon>
  );
}
